import React from 'react';

import { BUTTON_TYPES, EvButton, EvTableColumn } from '@evinced-private/ui-common';

import { LABEL_MANAGEMENT_EDIT_ACTION_DAID } from 'data-automation-ids/LabelManagementAutomationIds';

import { Label, LabelValue } from '../../types';

import { ValuesCell } from './cells';
import { LABELS_TABLE_COLUMN_WIDTHS } from './LabelsTable.constants';
import { LABELS_TABLE_LABELS } from './LabelsTable.labels';

export const getLabelsTableColumns = (
	onEdit: (label: Label) => void,
	onShowMore: (label: Label) => void
): EvTableColumn[] => [
	{
		dataField: 'key',
		text: LABELS_TABLE_LABELS.COLUMN_KEY,
		sort: true,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.KEY },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.KEY }
	},
	{
		dataField: 'displayName',
		text: LABELS_TABLE_LABELS.COLUMN_DISPLAY_NAME,
		sort: true,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.DISPLAY_NAME },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.DISPLAY_NAME }
	},
	{
		dataField: 'type',
		text: LABELS_TABLE_LABELS.COLUMN_TYPE,
		sort: true,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.TYPE },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.TYPE }
	},
	{
		dataField: 'values',
		text: LABELS_TABLE_LABELS.COLUMN_VALUES,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.VALUES },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.VALUES },
		formatter: (values: LabelValue[], row: Label) => (
			<ValuesCell values={values.map((v) => v.value)} onShowMore={() => onShowMore(row)} />
		)
	},
	{
		dataField: 'actions',
		text: LABELS_TABLE_LABELS.COLUMN_ACTIONS,
		style: { width: LABELS_TABLE_COLUMN_WIDTHS.ACTIONS },
		headerStyle: { width: LABELS_TABLE_COLUMN_WIDTHS.ACTIONS },
		formatter: (_cell: unknown, row: Label) => (
			<EvButton
				type={BUTTON_TYPES.GHOST}
				dataAutomationId={LABEL_MANAGEMENT_EDIT_ACTION_DAID}
				onClick={() => onEdit(row)}
			>
				{LABELS_TABLE_LABELS.EDIT_ACTION}
			</EvButton>
		)
	}
];
